import * as config from '../../../wips.config.js';
import { ContextService } from '../../../services/context_service';
import { DatenverwaltungBundeslaender } from './DatenverwaltungBundeslaender';
import { DatenverwaltungDateien } from './DatenverwaltungDateien';
import { DatenverwaltungFoerderung } from './DatenverwaltungFoerderung';
import { DatenverwaltungFoerderungZuordnung } from './DatenverwaltungFoerderungZuordnung';
import { DatenverwaltungPartner } from './DatenverwaltungPartner';
import { DatenverwaltungPartnerZuordnung } from './DatenverwaltungPartnerZuordnung';
import { DatenverwaltungGlossarZuordnung } from './DatenverwaltungGlossarZuordnung';
import { DatenverwaltungKontaktFaq } from './DatenverwaltungKontaktFaq';
import { DatenverwaltungKontaktFaqZuordnung } from './DatenverwaltungKontaktFaqZuordnung';
import { DatenverwaltungMedien } from './DatenverwaltungMedien';
import { DatenverwaltungSystemparameter } from './DatenverwaltungSystemparameter';
import { DatenverwaltungSystemtexteZuordnung } from './DatenverwaltungSystemtexteZuordnung';
import { DatenverwaltungZertifizierungZuordnung } from './DatenverwaltungZertifizierungZuordnung';
import { DatenverwaltungZertifizierungsoptionen } from './DatenverwaltungZertifizierungsoptionen';
import { DatenverwaltungPlausibilisierung } from './DatenverwaltungPlausibilisierung';
import { lazyInject } from '../../../services/inversify';
import { MehrsprachigkeitFaq } from './mehrsprachigkeit/MehrsprachigkeitFaq';
import { MehrsprachigkeitGlossar } from './mehrsprachigkeit/MehrsprachigkeitGlossar';
import { MehrsprachigkeitSystemtexte } from './mehrsprachigkeit/MehrsprachigkeitSystemtexte';
import { MehrsprachigkeitOnlineHilfe } from './mehrsprachigkeit/MehrsprachigkeitOnlineHilfe';
import * as React from 'react';
import { Routing } from '../../../helpers/Routing';
import { RoutingIDs } from '../../../helpers/RoutingAdminIDs';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';

interface DatenverwaltungTabInhalteSupportParameterProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
    standortSelected: any;
}

interface DatenverwaltungTabInhalteSupportParameterState {
    tabIndex: number;
}

export class DatenverwaltungTabInhalteSupportParameter extends
    React.Component<DatenverwaltungTabInhalteSupportParameterProps, DatenverwaltungTabInhalteSupportParameterState> {

    constructor(props: any) {
        super(props);
        this.state = {
            tabIndex: null
        };
    }

    @lazyInject(ContextService) private contextService: ContextService;

    private devFeatures: boolean = config.devFeatures || false;
    private devFeaturesMap: any = config.devFeaturesMap || {};
    private disabled: string[] = [];
    private prefix: string = 'admin.tab.datenverwaltung.inhalte';
    private rechte: any = {};
    private tabName: string = RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER;
    private tabIndex: string = `${this.tabName}Index`;
    private tabRoutings: any[] = [
        { path: RoutingIDs.ROUTE_INHALTE_SUPPORT_PARAMETER_FAQ },
        { path: RoutingIDs.ROUTE_INHALTE_SUPPORT_PARAMETER_GLOSSAR },
        { path: RoutingIDs.ROUTE_INHALTE_SUPPORT_PARAMETER_GLOSSAR_ZUORDNUNG },
        { path: RoutingIDs.ROUTE_INHALTE_SUPPORT_PARAMETER_SYSTEMTEXTE },
        { path: RoutingIDs.ROUTE_INHALTE_SUPPORT_PARAMETER_SYSTEMTEXTE_ZUORDNUNG },
        { path: RoutingIDs.ROUTE_INHALTE_SUPPORT_PARAMETER_ONLINE_HILFE },
        { path: RoutingIDs.ROUTE_INHALTE_SUPPORT_PARAMETER_BUNDESLAENDER },
        { path: RoutingIDs.ROUTE_INHALTE_SUPPORT_PARAMETER_ZERTIFIZIERUNGSOPTIONEN },
        { path: RoutingIDs.ROUTE_INHALTE_SUPPORT_PARAMETER_ZERTIFIZIERUNG_ZUORDNUNG },
        { path: RoutingIDs.ROUTE_INHALTE_SUPPORT_PARAMETER_FOERDERUNG },
        { path: RoutingIDs.ROUTE_INHALTE_SUPPORT_PARAMETER_FOERDERUNG_ZUORDNUNG },
        { path: RoutingIDs.ROUTE_INHALTE_SUPPORT_PARAMETER_PARTNER },
        { path: RoutingIDs.ROUTE_INHALTE_SUPPORT_PARAMETER_PARTNER_ZUORDNUNG },
        { path: RoutingIDs.ROUTE_INHALTE_SUPPORT_PARAMETER_SYSTEMPARAMETER },
        { path: RoutingIDs.ROUTE_INHALTE_SUPPORT_PARAMETER_DATEIEN },
        { path: RoutingIDs.ROUTE_INHALTE_SUPPORT_PARAMETER_MEDIEN },
        { path: RoutingIDs.ROUTE_INHALTE_SUPPORT_PARAMETER_PLAUSIBILISIERUNG },
        { path: RoutingIDs.ROUTE_INHALTE_SUPPORT_PARAMETER_KONTAKT_FAQ },
        { path: RoutingIDs.ROUTE_INHALTE_SUPPORT_PARAMETER_KONTAKT_FAQ_ZUORDNUNG }
    ];
    private tabs: string[] = [ // Reitereihenfolge beachten
        'faq', 'glossar', 'glossar_zuordnung', 'systemtexte', 'systemtexte_zuordnung', 'online_hilfe', 'bundeslaender',
        'zertifizierungsoptionen', 'zertifizierung_zuordnung', 'foerderung', 'foerderung_zuordnung', 'partner', 'partner_zuordnung',
        'systemparameter', 'systemtexte', 'systemtexte', 'plausibilisierung', 'kontakt_faq', 'kontakt_faq_zuordnung'
    ];

    componentDidMount(): void {
        if (!this.devFeatures) {
            this.disabled = [...this.disabled, 'kontakt_faq', 'kontakt_faq_zuordnung'];
        }

        if (!this.devFeaturesMap.N214_FAQ) {
            this.disabled = [...this.disabled, 'faq'];
        }
        (new Routing(this)).init((rechte: any, tabIndex: number) => {
            this.rechte = rechte || {};
            this.setTabIndex(tabIndex, this.tabRoutings[tabIndex]);
        });
    }

    componentDidUpdate(prevProps: any): void {
        if (JSON.stringify(this.props.routing) !== JSON.stringify(prevProps.routing)) {
            this.checkRouting();
        }
    }

    checkRouting(): void {
        const routing: any = this.props.routing || {};
        if (typeof (routing.path || {})[this.tabName] === 'undefined') {
            return;
        }
        // this.setTabIndex(routing.path[this.tabName], routing, () => {
        //     if (routing.path.terminateOn === this.tabName) {
        //         this.props.onRoutingChange({});
        //     }
        // });
        if (this.state.tabIndex === routing.path[this.tabName]) {
            if (routing.path.terminateOn === this.tabName) {
                this.props.onRoutingChange({});
            }
        } else {
            this.setTabIndex(routing.path[this.tabName], routing);
        }
    }

    render(): JSX.Element {
        if (this.state.tabIndex === null) {
            return null;
        }

        return (
            <Tabs
                className='tabs-admin-datenverwaltung'
                selectedIndex={this.state.tabIndex}
                onSelect={(tabIndex, lastIndex, event) => this.setTabIndex(tabIndex, this.tabRoutings[tabIndex])}
            >
                <TabList>
                    <Tab disabled={!this.rechte.faq}>FAQ</Tab>
                    <Tab disabled={!this.rechte.glossar}>Glossar</Tab>
                    <Tab disabled={!this.rechte.glossar_zuordnung}>Glossar-Zuordnung</Tab>
                    <Tab disabled={!this.rechte.systemtexte}>Systemtexte</Tab>
                    <Tab disabled={!this.rechte.systemtexte_zuordnung}>Systemtexte-Zuordnung</Tab>
                    <Tab disabled={!this.rechte.online_hilfe}>Online-Hilfe</Tab>
                    <Tab disabled={!this.rechte.bundeslaender}>Bundesländer</Tab>
                    <Tab disabled={!this.rechte.zertifizierungsoptionen}>Zertifizierungsoptionen</Tab>
                    <Tab disabled={!this.rechte.zertifizierung_zuordnung}>Zertifizierung-Zuordnung</Tab>
                    <Tab disabled={!this.rechte.foerderung}>Förderung</Tab>
                    <Tab disabled={!this.rechte.foerderung_zuordnung}>Förderung-Zuordnung</Tab>
                    <Tab disabled={!this.rechte.partner}>Partner:innen</Tab>
                    <Tab disabled={!this.rechte.partner_zuordnung}>Partner:innen-Zuordnung</Tab>
                    <Tab disabled={!this.rechte.systemparameter}>Systemparameter</Tab>
                    <Tab disabled={!this.rechte.systemtexte}>Dateien</Tab>
                    <Tab disabled={!this.rechte.systemtexte}>Medien</Tab>
                    <Tab disabled={!this.rechte.plausibilisierung}>Plausibilisierung</Tab>
                    <Tab disabled={!this.rechte.kontakt_faq}>Kontakt-FAQ</Tab>
                    <Tab disabled={!this.rechte.kontakt_faq_zuordnung}>Kontakt-FAQ-Zuordnung</Tab>
                </TabList>
                <TabPanel>
                    {this.rechte.faq &&
                        <MehrsprachigkeitFaq
                            admin
                            data={this.props.data}
                        />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.glossar &&
                        <MehrsprachigkeitGlossar
                            admin
                            data={this.props.data}
                        />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.glossar_zuordnung &&
                        <DatenverwaltungGlossarZuordnung />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.systemtexte &&
                        <MehrsprachigkeitSystemtexte
                            admin
                            data={this.props.data}
                        />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.systemtexte_zuordnung &&
                        <DatenverwaltungSystemtexteZuordnung
                            data={this.props.data}
                        />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.online_hilfe &&
                        <MehrsprachigkeitOnlineHilfe
                            data={this.props.data}
                        />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.bundeslaender &&
                        <DatenverwaltungBundeslaender />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.zertifizierungsoptionen &&
                        <DatenverwaltungZertifizierungsoptionen />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.zertifizierung_zuordnung &&
                        <DatenverwaltungZertifizierungZuordnung
                            data={this.props.data}
                        />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.foerderung &&
                        <DatenverwaltungFoerderung />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.foerderung_zuordnung &&
                        <DatenverwaltungFoerderungZuordnung
                            data={this.props.data}
                        />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.partner &&
                        <DatenverwaltungPartner />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.partner_zuordnung &&
                        <DatenverwaltungPartnerZuordnung
                            data={this.props.data}
                        />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.systemparameter &&
                        <DatenverwaltungSystemparameter />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.systemtexte &&
                        <DatenverwaltungDateien />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.systemtexte &&
                        <DatenverwaltungMedien admin />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.plausibilisierung &&
                        <DatenverwaltungPlausibilisierung />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.kontakt_faq &&
                        <DatenverwaltungKontaktFaq />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.kontakt_faq_zuordnung &&
                        <DatenverwaltungKontaktFaqZuordnung
                            data={this.props.data}
                        />
                    }
                </TabPanel>
            </Tabs>
        );
    }

    setTabIndex(tabIndex: number, tabRouting: any, callback?: () => void): void {
        if (this.state.tabIndex !== tabIndex) {
            setTimeout(() => {
                this.setState({ tabIndex }, () => {
                    this.props.onRoutingChange(tabRouting);
                    this.contextService.set(this.tabIndex, tabIndex);

                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            });
        }
    }
}
